// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"b30d10e81b9a91a8","867":"8b3bdf59f0bfa4ca","868":"121b25e86d6cd2c9","960":"475595e8b0850d8a"}[chunkId] + ".css";
};